import React from 'react';
import DateRangeMenu, {
  NO_DATE_BOUNDS,
} from '../../../../../../shared/designSystem/components/DateRangeMenu';

// =============================================================================
// SummaryRangeSelector — Summary tab page-level range picker.
//
// Migrated from the segmented `<DateRangePicker>` (pills + Custom popover)
// to the modern single-trigger `<DateRangeMenu>` (one labelled pill →
// popover with presets-on-left + calendar-on-right). 2024-25 dashboard
// convention (Linear / Stripe / GA4 / shadcn-DRP). Trial swap on Summary
// only — other consumers stay on `<DateRangePicker>` for now.
//
// Owns the Summary-specific extra: keeping the chart's internal
// `useByDateFilter` (`setRangeKey`) in sync with the segmented preset state
// (now fired from a preset-list click instead of a pill click).
//
// Two state silos still flow as before:
//   - `bySummaryRangeDate` drives the KPI bar
//   - `rangeKey` (via `setRangeKey`) drives the chart's filter
//
// Date semantics unchanged. The new primitive consumes the same
// `getTimezoneAwareRanges(timezone)` source so `Last 7 Days` etc. resolve
// to the same windows develop's preset menu used.
// =============================================================================
// `disabledDate` defaults to NO_DATE_BOUNDS for the same reason as
// CampaignRangeSelector: `defaultDateRange` is the campaign flight window,
// while the presets are today-relative, so the implicit clamp would gate them
// on a finished campaign (#11685).
const SummaryRangeSelector = ({
  rangeType,
  bySummaryRangeDate,
  setRangeType,
  setBySummaryRangeDate,
  setRangeKey,
  timezone = 'UTC',
  defaultDateRange,
  disabledDate = NO_DATE_BOUNDS,
}) => {
  const handleRangeTypeChange = (key) => {
    if (setRangeType) setRangeType(key);
    if (setRangeKey) setRangeKey(key);
  };

  return (
    <DateRangeMenu
      rangeType={rangeType}
      onRangeTypeChange={handleRangeTypeChange}
      value={bySummaryRangeDate}
      onChange={setBySummaryRangeDate}
      defaultDateRange={defaultDateRange}
      disabledDate={disabledDate}
      timezone={timezone}
    />
  );
};

export default SummaryRangeSelector;
